import { useRef, useEffect } from 'react'
import { Field } from 'formik'
import styled from 'styled-components'
import { Flex, Box } from '../../ui/Layout'
import { Text, Label } from '../../ui/Typography'
import { Input, TextArea } from '../../ui/Input'
import Button from '../../ui/Button'
import withFormik from '../../ui/formikFormWrapper'
import { useForm } from '../../context/FormContext'
import { Container } from '../Intro'
import { useFormConfig } from '../../context/FormConfigContext'

const FormikInput = withFormik(Input)
const FormikTextArea = withFormik(TextArea)

const VideoPreview = styled.video`
  width: 100%;
  border-radius: 8px;
  margin-bottom: 16px;
`

const ProgressBar = styled(Flex)`
  background-color: #f7fafc;
  height: 16px;
  border-radius: 16px;
  transition: width 1s;
  width: 100%;
`

const ProgressBarProgress = styled(ProgressBar)`
  background: linear-gradient(225deg, #bb65ff 0%, #4c6fff 100%);
  ${(props) => (props.finished ? 'background: linear-gradient(225deg, #67E9F1 0%, #24E795 100%);' : null)}
`

const ErrorText = styled(Text)`
  color: #ff4444;
  margin: 8px 0;
`

const Review = ({ videoBlob, onBack, isSubmitting, setIsSubmitting, uploadProgress, uploadError }) => {
  const videoRef = useRef(null)
  const { formConfig } = useFormConfig()
  const videoUrl = useRef(URL.createObjectURL(videoBlob))
  const { handleSubmit } = useForm()

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load()
    }
  }, [])

  return (
    <Container>
      <Text fontSize="24px" fontWeight="600" mb="24px">
        Review your testimonial
      </Text>

      <VideoPreview
        ref={videoRef}
        src={videoUrl.current}
        controls
        playsInline
        webkit-playsinline="true"
        x-webkit-airplay="allow"
        preload="metadata"
      />

      <Flex>
        <Button width="100%" variant="secondary" label="Record again" onClick={onBack} mb="24px" />
      </Flex>

      {uploadError && <ErrorText>{uploadError}</ErrorText>}

      <Label>You can also leave us a text review:</Label>
      <Field
        mb="24px"
        name="review"
        label="Your review"
        placeholder="Write your review here..."
        minHeight="120px"
        component={FormikTextArea}
      />

      <Field mb="24px" dark name="name" label="Your name" placeholder="Your name" component={FormikInput} />

      <Field mb="24px" dark name="email" label="Email" type="email" placeholder="Your email" component={FormikInput} />

      {isSubmitting ? (
        <Flex flexDirection="column" width="100%" mb="24px">
          <Text>Uploading video...</Text>
          <ProgressBar>
            <ProgressBarProgress finished={uploadProgress === 100} width={`${uploadProgress}%`} />
          </ProgressBar>
          <Text fontSize="14px" color="gray">
            {Math.round(uploadProgress)}% complete
          </Text>
        </Flex>
      ) : (
        <>
          <Flex>
            <Button
              large
              backgroundColor={formConfig.buttonColor}
              mb="24px"
              width="100%"
              variant="black"
              label="Submit"
              isLoading={isSubmitting}
              onClick={handleSubmit}
              isDisabled={uploadProgress > 0 && uploadProgress < 100}
            />
          </Flex>
          <Text fontSize="12px" color="gray">
            By submitting your content you give us the right to use your content for marketing purposes.
          </Text>
        </>
      )}
    </Container>
  )
}

export default Review
